(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-cart-dialog]');
    const openButton = document.querySelector('[data-cart-drawer-open]');
    if (!drawer || drawer.dataset.initialized === 'true') return;
    drawer.dataset.initialized = 'true';

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, drawer.dataset.moneyFormat);
      }
      const currency = drawer.dataset.currency || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents) / 100);
      } catch {
        return `${(Number(cents) / 100).toFixed(2)} ${currency}`;
      }
    };

    let cartRenderRequest = 0;
    let activeToast;
    let toastStylesPromise;
    let toastScriptPromise;
    let toastRequestId = 0;

    const ensureToastStyles = () => {
      if (!toastStylesPromise) {
        toastStylesPromise = new Promise((resolve) => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = drawer.dataset.toastStylesheetUrl;
          link.addEventListener('load', resolve, { once: true });
          link.addEventListener('error', resolve, { once: true });
          document.head.append(link);
        });
      }
      return toastStylesPromise;
    };

    const ensureToastScript = () => {
      if (!toastScriptPromise) {
        toastScriptPromise = new Promise((resolve) => {
          const script = document.createElement('script');
          script.src = drawer.dataset.toastScriptUrl;
          script.addEventListener('load', resolve, { once: true });
          script.addEventListener('error', resolve, { once: true });
          document.head.append(script);
        });
      }
      return toastScriptPromise;
    };

    const clearToast = () => {
      toastRequestId += 1;
      activeToast?.hideToast();
      activeToast = null;
    };
    const showToast = async (message, kind = 'error') => {
      clearToast();
      const requestId = toastRequestId;
      await Promise.all([ensureToastStyles(), ensureToastScript()]);
      if (requestId !== toastRequestId) return;
      if (typeof window.Toastify !== 'function') {
        const notice = document.createElement('p');
        notice.setAttribute('role', kind === 'error' ? 'alert' : 'status');
        notice.textContent = message;
        drawer.querySelector('.pdp-cart__panel').prepend(notice);
        activeToast = { hideToast: () => notice.remove() };
        return;
      }
      const toast = window.Toastify({
        text: message,
        duration: kind === 'error' ? -1 : 3000,
        close: kind === 'error',
        gravity: 'top',
        position: 'right',
        selector: drawer.querySelector('.pdp-cart__panel'),
        className: `pdp-cart__toast pdp-cart__toast--${kind}`,
        ariaLive: kind === 'error' ? 'assertive' : 'polite',
        callback: () => { if (activeToast === toast) activeToast = null; },
      }).showToast();
      toast.toastElement.querySelector('.toast-close')?.setAttribute('aria-label', drawer.dataset.closeLabel);
      activeToast = toast;
    };

    const updateCount = (cart) => {
      const itemCount = Number(cart.item_count || 0);
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = String(itemCount);
        node.hidden = itemCount < 1;
      });

      const heading = drawer.querySelector('[data-cart-heading]');
      if (heading) heading.textContent = drawer.dataset.cartHeadingFormat.replace('__count__', String(itemCount));

      const shippingMessage = drawer.querySelector('[data-cart-shipping-message]');
      const shippingNote = drawer.querySelector('[data-cart-shipping-note]');
      const shippingValue = drawer.querySelector('[data-cart-shipping-value]');
      const shippingIcon = drawer.querySelector('[data-cart-shipping-icon]');
      const shippingBanner = drawer.querySelector('.pdp-cart__shipping-progress');
      const eligible = (cart.requires_shipping ?? cart.items?.some((item) => item.requires_shipping)) && drawer.dataset.currency === 'USD';
      const remaining = Number(drawer.dataset.shippingThreshold) - Number(cart.total_price || 0);
      if (shippingBanner) shippingBanner.hidden = !eligible;
      if (shippingMessage) {
        shippingMessage.textContent = remaining <= 0
          ? drawer.dataset.shippingUnlockedLabel
          : drawer.dataset.shippingRemainingFormat.replace('__amount__', formatMoney(remaining));
      }
      if (shippingNote) shippingNote.textContent = remaining <= 0 ? drawer.dataset.shippingUnlockedNote : drawer.dataset.shippingCheckoutNote;
      if (shippingValue) shippingValue.textContent = eligible ? (remaining <= 0 ? drawer.dataset.shippingFreeValue : formatMoney(Number(drawer.dataset.shippingFee))) : drawer.dataset.shippingCheckoutValue;
      if (shippingIcon) shippingIcon.textContent = remaining <= 0 ? '✓' : '$';
      shippingBanner?.classList.toggle('is-unlocked', eligible && remaining <= 0);
      return eligible && remaining > 0 ? Number(drawer.dataset.shippingFee) : 0;
    };

    const renderCart = async (cart) => {
      if (!cart) return;
      const requestId = ++cartRenderRequest;
      try {
        let html = cart.sections?.['cart-drawer-items'];
        if (!html) {
          const sectionUrl = new URL(window.location.href);
          sectionUrl.searchParams.set('section_id', 'cart-drawer-items');
          const response = await fetch(sectionUrl, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(drawer.dataset.cartUpdateErrorLabel);
          html = await response.text();
        }
        const itemsNode = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-items]');
        if (!itemsNode) throw new Error(drawer.dataset.cartUpdateErrorLabel);
        if (requestId !== cartRenderRequest) return;
        drawer.querySelector('[data-cart-items]').replaceWith(itemsNode);
      } catch {
        if (requestId === cartRenderRequest) {
          drawer.querySelectorAll('[data-cart-item][aria-busy]').forEach((row) => {
            row.removeAttribute('aria-busy');
            row.querySelectorAll('button').forEach((button) => { button.disabled = false; });
          });
          showToast(drawer.dataset.cartUpdateErrorLabel);
        }
        return;
      }

      const referenceSubtotal = Number(drawer.querySelector('[data-cart-items]').dataset.referenceSubtotal || 0);
      const emptyNode = drawer.querySelector('[data-cart-empty]');
      const summaryNode = drawer.querySelector('[data-cart-summary]');
      emptyNode.hidden = Number(cart.item_count || 0) > 0;
      summaryNode.hidden = Number(cart.item_count || 0) < 1;
      const estimatedTotal = Number(cart.total_price || 0) + updateCount(cart);
      const total = drawer.querySelector('[data-cart-total]');
      if (total) total.textContent = formatMoney(estimatedTotal);
      const subtotal = drawer.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(referenceSubtotal);
      const subtotalLabel = drawer.querySelector('[data-cart-subtotal-label]');
      if (subtotalLabel) subtotalLabel.textContent = drawer.dataset.subtotalCountFormat.replace('__count__', String(cart.item_count || 0));
      const cartDiscount = Math.max(0, referenceSubtotal - Number(cart.total_price || 0));
      const discount = drawer.querySelector('[data-cart-discount]');
      const discountRow = drawer.querySelector('[data-cart-discount-row]');
      if (discount) discount.textContent = `−${formatMoney(cartDiscount)}`;
      if (discountRow) discountRow.hidden = cartDiscount <= 0;
    };

    const openDrawer = () => {
      if (drawer.open) return;
      if (typeof drawer.showModal === 'function') drawer.showModal();
      else drawer.setAttribute('open', '');
      window.dispatchEvent(new Event('cart:opened'));
    };

    const closeDrawer = () => {
      if (typeof drawer.close === 'function' && drawer.open) drawer.close();
      else drawer.removeAttribute('open');
    };

    const openWithCurrentCart = () => {
      clearToast();
      openDrawer();
    };

    const changeCartItem = async (button, quantity) => {
      if (button.disabled) return;
      const row = button.closest('[data-cart-item]');
      const actionButtons = row?.querySelectorAll('button') || [button];
      actionButtons.forEach((action) => { action.disabled = true; });
      row?.setAttribute('aria-busy', 'true');
      clearToast();

      try {
        const response = await fetch(drawer.dataset.cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: button.dataset.lineKey, quantity, sections: ['cart-drawer-items'], sections_url: window.location.pathname }),
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || (quantity === 0 ? drawer.dataset.removeErrorLabel : drawer.dataset.cartUpdateErrorLabel));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if (quantity === 0) showToast(drawer.dataset.removedLabel, 'success');
      } catch (error) {
        actionButtons.forEach((action) => { action.disabled = false; });
        row?.removeAttribute('aria-busy');
        showToast(error instanceof Error ? error.message : drawer.dataset.cartUpdateErrorLabel);
      }
    };

    openButton?.addEventListener('click', openWithCurrentCart);
    drawer.querySelector('[data-cart-close]')?.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const removeButton = target.closest('[data-cart-remove]');
      const quantityButton = target.closest('[data-cart-quantity-change]');
      if (removeButton) changeCartItem(removeButton, 0);
      else if (quantityButton) {
        const nextQuantity = Number(quantityButton.dataset.quantity) + Number(quantityButton.dataset.quantityDelta);
        if (nextQuantity >= 0) changeCartItem(quantityButton, nextQuantity);
      } else if (target === drawer) closeDrawer();
    });
    drawer.addEventListener('close', () => {
      clearToast();
      const headerHidden = document.documentElement.classList.contains('pdp-header-reveal-enabled')
        && window.matchMedia('(max-width: 749px)').matches
        && !document.body.hasAttribute('data-pdp-header-visible');
      const focusTarget = headerHidden ? document.querySelector('[data-add-button]') : openButton;
      focusTarget?.focus({ preventScroll: true });
    });
    window.addEventListener('cart:notice', (event) => showToast(event.detail?.message || drawer.dataset.cartConfirmedFallbackLabel));
    window.addEventListener('cart:updated', (event) => {
      clearToast();
      renderCart(event.detail?.cart || event.detail);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-exit-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-cart-exit]');
    if (!dialog || !dialog.showModal) return;
    window.showCartExitModal = () => {
      if (dialog.open) return;
      dialog.showModal();
    };
    dialog.querySelectorAll('[data-exit-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.querySelector('[data-exit-open-cart]')?.addEventListener('click', (event) => {
      const openCartButton = document.querySelector('[data-cart-drawer-open]');
      if (!openCartButton) return;
      event.preventDefault();
      dialog.close();
      openCartButton.click();
    });

    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const key = 'cart-exit-shown';
    let shown = false;
    let checking = false;
    try { shown = sessionStorage.getItem(key) === '1'; } catch { return; }
    if (shown) return;

    const onExit = async (event) => {
      if (event.clientY > 0 || event.relatedTarget || checking || dialog.open || document.querySelector('[data-cart-dialog][open]')) return;
      checking = true;
      try {
        const response = await fetch(dialog.dataset.cartUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (!cart.item_count || document.visibilityState !== 'visible') return;
        sessionStorage.setItem(key, '1');
        document.removeEventListener('mouseout', onExit);
        dialog.showModal();
      } catch { return; }
      finally { checking = false; }
    };
    document.addEventListener('mouseout', onExit);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-timer"] && !Shopify.designMode) return;
  try {
    (() => {
    const timers = [...document.querySelectorAll('[data-cart-timer]')];
    if (!timers.length) return;

    const storageKey = 'cart-checkout-reminder-deadline';
    const duration = 15 * 60 * 1000;
    let fallbackDeadline = null;
    let itemCount = Number(timers[0].dataset.cartItemCount) || 0;
    let cartStateVersion = 0;

    const readDeadline = () => {
      try {
        const stored = window.localStorage.getItem(storageKey);
        return stored === null ? fallbackDeadline : Number(stored);
      } catch {
        return fallbackDeadline;
      }
    };

    const saveDeadline = (deadline) => {
      fallbackDeadline = deadline;
      try {
        if (deadline === null) window.localStorage.removeItem(storageKey);
        else window.localStorage.setItem(storageKey, String(deadline));
      } catch {}
    };

    const render = () => {
      const deadline = readDeadline();
      const seconds = deadline === null || !Number.isFinite(deadline) ? 0 : Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      const display = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
      timers.forEach((timer) => {
        timer.hidden = itemCount < 1 || deadline === null || !Number.isFinite(deadline) || deadline <= Date.now();
        timer.querySelector('[data-cart-timer-time]').textContent = display;
      });
    };

    const start = () => {
      if (itemCount < 1) return;
      const deadline = readDeadline();
      if (deadline === null || !Number.isFinite(deadline) || deadline <= Date.now()) saveDeadline(Date.now() + duration);
      render();
    };

    const syncCart = async (startIfOpen = false) => {
      const version = cartStateVersion;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (version !== cartStateVersion || typeof cart.item_count !== 'number') return;
        cartStateVersion += 1;
        itemCount = cart.item_count;
        if (itemCount < 1) saveDeadline(null);
        else if (startIfOpen && document.querySelector('[data-cart-dialog]')?.open) start();
        render();
      } catch {}
    };

    if (itemCount < 1) saveDeadline(null);
    if (document.querySelector('.cart-page') && itemCount > 0) start();
    else render();

    window.addEventListener('cart:opened', () => {
      if (itemCount < 1) syncCart(true);
      else start();
    });
    window.addEventListener('cart:updated', (event) => {
      const cart = event.detail?.cart || event.detail;
      if (typeof cart?.item_count !== 'number') return;
      cartStateVersion += 1;
      itemCount = cart.item_count;
      if (itemCount < 1) saveDeadline(null);
      else if (document.querySelector('[data-cart-dialog]')?.open || document.querySelector('.cart-page')) start();
      render();
    });
    window.addEventListener('storage', (event) => {
      if (event.key === storageKey) {
        render();
        syncCart();
      }
    });
    window.setInterval(render, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
